export { default as useReportRoute } from './useReportRoute';
